import { ComponentProps } from 'react';
import { languageCountryMap, TranslationLanguage } from '@/shared/i18n/constants';
import { cn } from '@/shared/lib/cn';
import './flag.scss';

type Props = ComponentProps<'div'> & {
    language: `${TranslationLanguage}`;
};

export const Flag = ({ language, className, ...props }: Props) => {
    const Component = languageCountryMap[language] ?? 'div';

    return (
        <div {...props} className={cn('flag', className)}>
            <Component className="flag__icon" />
        </div>
    );
};
